<template>
  <div class="home">
    <div v-if="christmasActive" class="christmasBanner" @click="openChristmas()">
        Zur Weihnachtsseite
    </div>
    <Christmas v-if="christmasActive" ref="christmas" @order="openOrder()"/>
    <div v-if="easterActive" class="easterBanner" @click="openEaster()">
      Zur Osterseite
    </div>
    <Easter v-if="easterActive" ref="easter"/>
    <Order ref="order"/>
    <div class="header">
      <h1 class="fat headline" v-html="title"></h1>
      <img src="@/assets/background_gfa.jpg" id="headerImg" class="headerImg">
      <div class="book">
        <h3>Hol dir das Gratis Buch zum Thema Glauben!</h3>
        <v-btn class="modernButton" @click="openOrder">Hier bestellen →</v-btn>
      </div>
    </div>

    <div class="questionContainerWrapper">
      <div class="questionContainer center">
        <div class="question fat">
          <p id="questionText"></p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bubbles" id="bubbles">
        <SpeechBubble v-for="(bubble, id) in answers"
                      :key="id"
                      :question-id=id
                      :short-message="bubble.short"
                      :long-message="bubble.description"
                      :anyExpanded=anyExpanded
                      @expand="onBubbleExpand"
                      @collapse="onBubbleCollapse"/>
        <ContactBubble :anyExpanded="anyExpanded"/>
      </div>
    </div>
  </div>
</template>

<script>
import SpeechBubble from "@/components/SpeechBubble";
import Headline from "@/components/Headline";
import Vue from "vue";
import Component from "vue-class-component";
import Typed from "typed.js";

import answers from "@/assets/answers";
import ContactBubble from "@/components/ContactBubble";
import Christmas from "@/views/Christmas";
import Easter from "@/views/Easter";
import Order from "@/views/Order";
import BasicComponent from "@/components/BasicComponent";

const questionText = "Mit dem Glauben tue ich mir schwer, weil:";

let mobileChecked = false;
let mobile = false;

function resizeQuestionContainer() {
  const element = document.getElementById("questionText");
  const contentBefore = element.innerText;
  element.innerText = questionText;
  const height = element.clientHeight;
  element.innerText = contentBefore;
  element.style.height = String(height) + "px";
}

function getViewportHeight() {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

function getViewportScrollTop() {
  return (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
}

function getViewportScrollBottom() {
  console.log("Scroll: " + getViewportScrollTop() + " " + getViewportHeight());
  return getViewportScrollTop() + getViewportHeight();
}

function isMobile() {
  if (mobileChecked) return mobile;
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  mobileChecked = true;
  return (mobile = check);
}

function resizeBubblesContainer() {
  if (isMobile()) return;
  const container = document.getElementById("bubbles");
  const containerBottomPosition = container.getBoundingClientRect().bottom;

  for (const bubble of container.childNodes) {
    const bubbleContent = bubble.getElementsByClassName("bubbleContent")[0];
    const prevTransition = bubbleContent.style.transition;
    bubbleContent.style.transition = "none"; // Height-changing transition has to be removed temporarily since we need to know the final height
    let bottomPosition = bubble.getBoundingClientRect().bottom;
    bubbleContent.style.transition = prevTransition;
    if (bubble.classList.contains("expanded")) {
      bubble.classList.remove("expanded");
      void bubble.offsetWidth; // Magic to restart the transition
      bubble.classList.add("expanded");
    }
    let diff = containerBottomPosition - bottomPosition;
    //console.log(diff);
    if (diff < 0) {
      //console.log(container.clientHeight);
      container.style.height = String(container.clientHeight - diff) + "px";
      return;
    }
  }
  container.style.height = "auto";
}

function getHost() {
  return window.location.host;
}

function isAt() {
  return window.location.host.toLowerCase().endsWith(".at");
}

@Component({
  components: {
    Order,
    Easter,
    Christmas,
    ContactBubble,
    SpeechBubble,
    Headline
  }
})
export default class Home extends BasicComponent {
  data() {
    return {
      answers: answers,
      anyExpanded: false
    }
  }

  mounted() {
    document.getElementById('headerImg').ondragstart = function () {
      return false;
    };
    resizeQuestionContainer();
    var typed = new Typed('#questionText', {
      strings: [questionText],
      typeSpeed: 20,
      showCursor: false
    });

    window.onresize = function (event) {
      resizeQuestionContainer();
    };

    if (this.$route.query.bestellen) {
      this.openOrder();
    }
    if (this.$route.query.s === "a") { // Adventskalender
      //this.openOrder();
    }
    //if (this.christmasActive) this.openChristmas();
    if (this.easterActive) this.openEaster();

  }

  onBubbleExpand() {
    this.$data.anyExpanded = true;
    Vue.nextTick(resizeBubblesContainer);
  }

  onBubbleCollapse() {
    this.$data.anyExpanded = false;
    Vue.nextTick(resizeBubblesContainer);
  }

  get title() {
    return isAt() ? "WERSGLAUBT.AT" : "WERSGLAUBT.DE";
  }

  get christmasActive() {
    return true || this.$route.query.christmas || this.$route.query.weihnachten;
  }

  get easterActive() {
    return false || this.$route.query.easter || this.$route.query.ostern;
  }

  openChristmas() {
    this.$refs.christmas.open();
  }

  openEaster() {
    this.$refs.easter.open();
  }

  openOrder() {
    this.$refs.order.open();
  }
}
</script>
<style scoped lang="scss">
@import "@/stylesheets/Variables.scss";
@import "@/stylesheets/SpeechBubble.scss";

$containerWidth: 1100px;

.christmasBanner {
  color: white;
  background-color: #BB3635;
  transform: rotateY(0deg) rotate(45deg);
  height: 40px;
  font-weight: 600;
  text-align: center;
  width: 300px;
  position: absolute;
  top: 70px;
  right: -70px;
  z-index: 5;
  font-size: 20px;
  line-height: 40px;

  &:hover {
    cursor: pointer;
  }
}

.easterBanner {
  @extend .christmasBanner;

  background-color: #088f2b;
}

.bookBanner {
  @extend .christmasBanner;

  background-color: #ff7700;
}

.home {
  overflow-x: hidden;

  .header {
    position: relative;

    .headline {
      text-align: center;
      font-weight: 700;
      position: absolute;
      width: 100%;
      z-index: 4;
      text-transform: uppercase;

      font-size: calc(5vw + 20px);

      @media screen and (min-width: 950px) {
        font-size: 67px;
      }

      @media screen and (max-width: 680px) {
        font-size: calc(4vw + 20px);
      }

    }

    .headerImg {
      $imageRatio: 3.1563;

      min-height: 40vh;
      min-width: 100vw;
      margin: 0 auto;
      z-index: -1;
      transform: translateX(calc((100vw - 100%) / 2));

      @media screen and (max-width: 680px) {
        max-height: calc(100vw / #{$imageRatio});
      }
    }

    .book {
      position: absolute;
      bottom: 0px;
      left: 65%;
      text-align: center;
      padding-right: 50px;

      h3 {
        font-variant: normal !important;
        font-weight: 700;
        font-size: 36px;
        text-align: left;
      }

      .v-btn {
        margin-top: 15px;
        float: left;
      }

      @media screen and (max-width: 680px) {
        margin-top: 20px;
        left: 0;
        padding: 20px;
        position: relative;

        h3 {
          text-align: center;
          font-size: 28px;
        }

        .v-btn {
          float: none;
        }
      }
    }

    max-width: 100vw;
  }

  .questionContainerWrapper {
    display: inline-block;
    margin: 0 auto;

    .questionContainer {
      max-width: $containerWidth;
      margin-top: 25px;
      margin-left: 5vw;
      margin-right: 5vw;

      .question {
        font-size: 22px;
        padding: 10px;

        p {
          text-transform: uppercase;
        }
      }
    }
  }

  .content {
    position: relative;

    .bubbles {
      margin: 0 5vw;

      padding: 30px 0;
      display: inline-grid;
      position: relative;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      align-content: start;
      align-items: start;
      grid-gap: 70px;
      min-height: 0;
      min-width: 0;

      width: 90vw;

      max-width: $containerWidth;

      @media screen and (max-width: 1155px) {
        max-width: 670px;
      }

      @media screen and (max-width: 330px) {
        grid-template-columns: repeat(auto-fill, minmax(90vw, 1fr));
      }

      .spaceHolder {
        height: 0;
        width: calc(#{$homeSpeechBubble-width} + 2 * (#{$homeSpeechBubble-padding} + #{$speechBubble-border-width}));
        visibility: hidden;
      }
    }
  }

}
</style>
